module.exports = __webpack_public_path__ + "img/notecase0.03af30bb.png";